import { Plus } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * Dashed-border "+" tile that lives inside a KB grid alongside the
 * real KB cards. Replaces the page-header "New knowledge base" button
 * so the create affordance sits at the same visual layer as the
 * existing items — and so empty states don't need a separate
 * placeholder block.
 */
export function KbCreateCard({
  onClick,
  label = 'New Knowledge Base',
  className,
}: {
  onClick: () => void;
  label?: string;
  className?: string;
}) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={cn(
          'group flex h-full min-h-[7rem] w-full flex-col items-center justify-center gap-2 rounded-md border border-dashed border-border bg-card/40 p-4 text-muted-foreground transition-colors hover:border-primary-500/50 hover:bg-accent/20 hover:text-foreground focus-visible:border-primary-500 focus-visible:bg-accent/20 focus-visible:text-foreground focus-visible:outline-none',
          className,
        )}
      >
        <Plus className="h-5 w-5" />
        <span className="text-sm font-medium">{label}</span>
      </button>
    </li>
  );
}
